/**
 * 견적서 PDF 주소를 대외 공유용 형태로 바꾼다.
 *
 *   /api/s3/proxy?key=...&download=견적서.pdf
 *   → /api/s3/proxy/견적서.pdf?key=...&download=견적서.pdf
 *
 * 왜: 브라우저 탭 제목과 PDF 뷰어 제목은 주소의 마지막 칸을 쓴다. 그래서 원래
 * 형태로 보내면 고객 화면에 파일명 대신 "proxy" 라고만 뜬다.
 * 내용은 key 가 정하므로 이름은 순수한 꾸밈이고, 서버는 두 형태를 똑같이 처리한다.
 *
 * 여기를 거치는 곳: 견적서 화면의 "PDF 링크" 복사, 메일 본문에 넣는 견적서 링크.
 */
export function shareablePdfUrl(pdfUrl) {
  if (!pdfUrl || !pdfUrl.startsWith('/api/s3/proxy?')) return pdfUrl;
  try {
    const qs = pdfUrl.slice(pdfUrl.indexOf('?') + 1);
    const q = new URLSearchParams(qs);
    const name = q.get('download');
    if (!name) return pdfUrl;
    return `/api/s3/proxy/${encodeURIComponent(name)}?${q.toString()}`;
  } catch {
    return pdfUrl;
  }
}
